export default "__VITE_ASSET__DgKFMso3__"